import Swiper from "swiper/bundle";
const hamburgerScripts = () => {
	const hamburger = document.querySelector(".hamburger-menu");
	const nav = document.querySelector(".fixed-navigation");
	const body = document.querySelector("body");
	const menuList = document.querySelectorAll(".fixed-navigation .all-menu-item");

	if (!hamburger || !nav || !body) {
		return;
	}

	hamburger.addEventListener("click", () => {
		hamburger.classList.toggle("active");
		nav.classList.toggle("active");
		body.classList.toggle("ofh");
	});

	// ヘッダーの場合のみ画面幅でactiveを切り替える

	if (menuList && window.innerWidth >= 768) {
		console.log(window.innerWidth);

		for (let i = 0; i < menuList.length; i++) {
			menuList[i].classList.add("active");
		}
	} else {
		for (let i = 0; i < menuList.length; i++) {
			menuList[i].classList.remove("active");
		}
	}
};

const fvSwiperScripts = () => {
	const fvSwiper = new Swiper(".fv-swiper", {
		slidesPerView: 1.2,
		spaceBetween: 20,
		centeredSlides: true,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
		},
	});
};

const bnrSwiperScripts = () => {
	const bnrSwiper = new Swiper(".bnr-swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		centeredSlides: true,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: ".bnr-swiper-button-next",
			prevEl: ".bnr-swiper-button-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
		},
	});
};

const clubSwiperScripts = () => {
	const swipers = document.querySelectorAll(".club-swiper");

	for (let i = 0; i < swipers.length; i++) {
		new Swiper(swipers[i], {
			slidesPerView: 1.5,
			spaceBetween: 30,
			centeredSlides: true,
			loop: true,
			speed: 1500,
			autoplay: {
				delay: 3000,
			},
			breakpoints: {
				768: {
					slidesPerView: 5.5,
				},
			},
		});
	}
};

const scrollHintScripts = () => {
	if (window.innerWidth > 600) return;

	const scrollHints = document.querySelectorAll(".scroll-hint");

	for (let i = 0; i < scrollHints.length; i++) {
		const newDiv = document.createElement("div");
		newDiv.classList.add("hint");
		newDiv.style.transition = "opacity .5s ease";
		scrollHints[i].appendChild(newDiv);
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (let i = 0; i < entries.length; i++) {
				const entry = entries[i];
				if (entry.isIntersecting) {
					const hintElement = entry.target.querySelector(".hint");
					if (hintElement) {
						hintElement.style.opacity = "1";
						setTimeout(() => {
							hintElement.style.opacity = "0";
						}, 1500);
					}
				}
			}
		},
		{
			root: null,
			threshold: 0.5,
		}
	);

	for (let i = 0; i < scrollHints.length; i++) {
		observer.observe(scrollHints[i]);
	}
};

const faqScripts = () => {
	const faqs = document.querySelectorAll(".faq-head");

	for (let i = 0; i < faqs.length; i++) {
		faqs[i].addEventListener("click", () => {
			const parent = faqs[i].closest('.faq-item');
			if (parent) {
				if (parent.classList.contains('active')) { // 修正箇所
					parent.classList.remove('active');
				} else {
					parent.classList.add('active');
				}
			}
		});
	}
}

const allMenuScripts = () => {
	const menuTriggers = document.querySelectorAll(".all-menu-heading");

	for (let i = 0; i < menuTriggers.length; i++) {
		menuTriggers[i].addEventListener("click", () => {
			const parent = menuTriggers[i].closest('.all-menu-item');
			if (parent) {
				if (parent.classList.contains('active')) { // 修正箇所
					parent.classList.remove('active');
				} else {
					parent.classList.add('active');
				}
			}
		});
	}
}

const smoothScroll = () => {
	const scrollLinks = document.querySelectorAll('a[href^="#"]');

	for (let i = 0; i < scrollLinks.length; i++) {
		scrollLinks[i].addEventListener("click", (e) => {
			e.preventDefault();
			const id = scrollLinks[i].getAttribute("href");
			document.querySelector(id).scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		});
	}
};

document.addEventListener("DOMContentLoaded", () => {
	hamburgerScripts();
	fvSwiperScripts();
	bnrSwiperScripts();
	scrollHintScripts();
	clubSwiperScripts();
	faqScripts();
	allMenuScripts();
	smoothScroll();
});
